<template>
  <v-container>
    <div class="limiter-content pa-3 pa-lg-0">
      <v-row>
        <v-col>
          <div class="font-weight-bold mt-10 mb-5 title-page" tabindex="0">Privacidade</div>
        </v-col>
      </v-row>

      <v-item-group class="ml-2 align-center">
        <v-row>
          <v-item>
            <template>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on" color="success" class="ml-1 mr-2">
                    mdi-check-circle-outline
                  </v-icon>
                </template>
                <span>Estas políticas estão vigentes e aceitas por você</span>
              </v-tooltip>
            </template>
          </v-item>
          <v-item>
            <div class="font-weight-bold mt-4 mb-5 pt-1" tabindex="0">Políticas vigentes</div>
          </v-item>
        </v-row>
      </v-item-group>

      <v-expansion-panels v-if="activeAcceptedPolicies.length > 0">
        <v-expansion-panel v-for="(policy, index) in activeAcceptedPolicies" :key="index" class="custom-panel">
          <v-expansion-panel-header class="header-text">
            {{ policy.privacy_type === 1 ? 'TERMOS DE USO' : 'POLÍTICA DE PRIVACIDADE' }} - VERSÃO {{ policy.version }}
            <template v-slot:actions>
              <v-icon color="white">$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list class="mb-n2 mt-3">
              <v-col class="pa-0">
                <v-row>
                  <v-col>
                    <div class="ml-3 mb-3">
                      Política vigente desde <span class="font-weight-medium">{{ formatDate(policy.created_at) }}</span>
                      e foi
                      aceita em
                      <span class="font-weight-medium">{{ formatDate(policy.accepted_at) }}</span>.
                    </div>
                  </v-col>
                </v-row>
                <v-list-item class="d-flex align-center">
                  <v-list-item-content class="d-flex justify-space-between align-center flex-grow-1">
                    <v-row class="d-flex align-left text-uppercase font-weight-medium mediumGray--text">
                      <v-col cols="12" sm="5">
                        <span>Visualizar {{ policy.privacy_type === 1 ? 'Termos de Uso' : 'Política de Privacidade'
                          }}</span>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-icon @click="downloadPolicy(policy)">
                    mdi-eye-outline
                  </v-icon>
                </v-list-item>
              </v-col>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-else class="mb-4">Não há políticas vigentes aceitas.</div>

      <v-item-group class="ml-2 align-center mt-6">
        <v-row>
          <v-item>
            <template>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on" color="warning" class="ml-1 mr-2 align-center">mdi-alert-circle-outline</v-icon>
                </template>
                <span>As Políticas abaixo não são mais válidas e não se aplicam mais a este site</span>
              </v-tooltip>
            </template>
          </v-item>
          <v-item>

            <div class="font-weight-bold mt-4 mb-5 pt-1" tabindex="0">Políticas anteriores</div>
          </v-item>
        </v-row>
      </v-item-group>

      <v-expansion-panels v-if="previousAcceptedPolicies.length > 0">
        <v-expansion-panel v-for="(policy, index) in previousAcceptedPolicies" :key="index" class="custom-panel">
          <v-expansion-panel-header class="header-text">
            {{ policy.privacy_type === 1 ? 'TERMOS DE USO' : 'POLÍTICA DE PRIVACIDADE' }} - VERSÃO {{ policy.version }}
            <template v-slot:actions>
              <v-icon color="white">$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list class="mb-n2 mt-3">
              <v-col class="pa-0">
                <v-row>
                  <v-col>
                    <div class="ml-3 mb-3">
                      Esta política é antiga e não se aplica mais a este site. Publicada em
                      <span class="font-weight-medium">{{ formatDate(policy.created_at) }}</span> e aceita em
                      <span class="font-weight-medium">{{ formatDate(policy.accepted_at) }}</span>.
                    </div>
                  </v-col>
                </v-row>
                <v-list-item class="d-flex align-center">
                  <v-list-item-content class="d-flex justify-space-between align-center flex-grow-1">
                    <v-row class="d-flex align-left text-uppercase font-weight-medium mediumGray--text">
                      <v-col cols="12" sm="5">
                        <span>Visualizar {{ policy.privacy_type === 1 ? 'Termos de Uso' : 'Política de Privacidade'
                          }}</span>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-icon @click="downloadPolicy(policy)">
                    mdi-eye-outline
                  </v-icon>
                </v-list-item>
              </v-col>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <div v-else class="mb-4">Não há políticas anteriores aceitas.</div>

      <br />

      <div class="mt-4" v-if="dataset.loading">
        <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
      </div>

      <div v-html="dataset.description" tabindex="0"></div>

      <div class="mt-10" v-if="!user">
        <h4>Por favor, realize o seu login para ter acesso à Central de Privacidade.</h4>
      </div>
    </div>
  </v-container>
</template>


<script>
import { eventHub } from '@/main'

import axios from 'axios'
import itemTypes from '@/common/data/item-types.data.js'

export default {
  name: 'PrivacyPage',

  data() {
    return {
      user: null,
      valid: true,
      search: '',
      previousAcceptedPolicies: [],
      activeAcceptedPolicies: [],
      savingDocuments: false,
      documents: [],
      newDocument: {},
      dataset: {
        itemTypes: itemTypes,
        loading: false,
        description: '',
        docs: [],
        activePolicy: null,
        previousPolicies: [],
        file_url: null
      },

    }
  },

  created() {
    if (this.$root.user) {
      this.user = this.$root.user
    }

    this.loadPolicies()
  },

  methods: {

    downloadPolicy(policy) {

      let userTypeName;

      if (this.user.profile === 1) {
        userTypeName = 'credor';
      } else if (this.user.profile === 4) {
        userTypeName = 'procurador';
      } else {
        throw new Error('Perfil de usuário inválido');
      }

      const documentName = policy.privacy_type === 1 ? 'termos-de-uso' : 'politica-de-privacidade';

      this.$router.push(`/arquivo/${documentName}-${userTypeName}-v${policy.version}?id=${policy.terms_id}`)
    },

    formatDate(dataString) {
      const data = new Date(dataString)
      const date = { day: '2-digit', month: '2-digit', year: 'numeric' }
      const hours = { hour: '2-digit', minute: '2-digit', second: '2-digit' }
      return data.toLocaleDateString('pt-BR', date) + ' ' + data.toLocaleTimeString('pt-BR', hours)
    },

    async loadPolicies() {

      const token = localStorage.getItem('token');
        
        if (!token || !this.user || !this.user.profile) return

        if (![1, 4].includes(this.user.profile)) {
            this.$dialog.notify.error('Perfil de usuário inválido', {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

       const profileLoad = this.user.profile === 1 ? '/api/users/policies/list-user' : '/api/lawyers/policies/list-lawyer'

      try {
        const response = await axios.get(profileLoad);

        const { activeAcceptedPolicies, previousAcceptedPolicies } = response.data.content;

        this.activeAcceptedPolicies = activeAcceptedPolicies;
        this.previousAcceptedPolicies = previousAcceptedPolicies;

      } catch (error) {
        console.error('Erro ao buscar políticas:', error);
      }
    },

  }
}
</script>


<style>
.custom-modal-title {
  font-size: 20px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
}
</style>
